window.mh = window.mh || {};
// Refine

var refine = {
   init:function () {
      $(".refine > h2").on('click', function(event) {
         event.preventDefault();
         /* Act on the event */
         $(".collection-filter").slideToggle('fast');
      });
   }
};

// collection filter
var collectionFilter = {
   init:function () {
      $(".mh-collection-menu select").on('change',  function(event) {
         // event.preventDefault();
         console.log($(this).val());
         window.location = $(this).val();
      });
   }
};
// wishlist
var wishlistData = [];
var wishlist = {

    init: function() {
        var that = this;
        console.log(wishlistData);
        that.wishlistAddedProduct();
        var heart = $(".icon-header-heart");
        function headerWishlistIcon(){
           var len = that.getWishlist().length;
           console.log(len);
           if (len) {
                heart.addClass('add-wishlist').removeClass('no-wishlist');
            }else{
                heart.addClass('no-wishlist').removeClass('add-wishlist');

            }
        }
       headerWishlistIcon();
        $(".wishlist a").on("click", function(e) {
            e.preventDefault();
            var self = $(this);
            var handle = self.data("handle")
            self.toggleClass('wishlist-added');


            wishlistData = that.getWishlist();
            that.addWishlist(wishlistData, handle);
            that.wishlistAddedProduct();
            headerWishlistIcon();
        })
    },
    getWishlist: function() {
        if (Cookies.get("wishlist")) {
            wishlistData = JSON.parse(Cookies.get("wishlist"));
            return wishlistData;
        }
        return [];
    },
    wishlistIndex: function(wishlistData, handle) {
      console.log(wishlistData);
        return wishlistData.indexOf(handle);
    },
    addWishlist: function(wishlistData, handle) {
        // check item already list or not
        var index = this.wishlistIndex(wishlistData, handle);

        if (!this.removeWishlist(wishlistData, index)) {
            wishlistData.push(handle);
            console.log('wishlist product added');
        }

        // save to database
        this.saveWishlist(wishlistData);
    },
    removeWishlist: function(wishlistData, index) {
        // check item already list or not

        if (index !== -1) {
            wishlistData.splice(index, 1);
            console.log('product removed');
            return true;
        }
        return false;
    },
    saveWishlist: function(wishlistData) {
        Cookies.set("wishlist", JSON.stringify(wishlistData),{ expires: 7 });
        console.log("save on Cookies");
    },
    wishlistAddedProduct: function() {
        wishlistData = this.getWishlist();
        var wishlistItem = $(".wishlist");
        if (wishlistData) {
          wishlistData.forEach(function(el, index) {
              if (wishlistItem.find('.' + el).length) {
                  wishlistItem.find('.' + el).addClass('wishlist-added')
              }
          });
        }
    },
    unload: function() {
        $(".wishlist a").off();
    }
};

// wishlist product fetch
var wishlistApp = new Vue({
    el: "#wishlist-app",
    delimiters: ['${', '}'],
    data: {
        products: [],
        wishlistData: []
    },
    created: function() {
        this.wishlistData = wishlist.getWishlist();
    },
    methods: {
        fetchWishlist: function() {
            var productHandleQueue = wishlist.getWishlist();

            function fetchProduct() {
                if (productHandleQueue.length) {
                    jQuery.ajax({
                        dataType: 'json',
                        url: '/products/' + productHandleQueue[0] + '.js',
                        cache: false,
                        success: function(product) {
                            wishlistApp.products.push(product);
                            productHandleQueue.shift();
                            fetchProduct();
                        },
                        error: function() {
                            //need to work
                            //cookie.remove(productHandleQueue[0]);
                            productHandleQueue.shift();
                            console.log("cannot fetch this products " + productHandleQueue[0]);
                            fetchProduct();
                        }
                    });
                } else {
                    // finalize();
                }
            }
            fetchProduct();
        },
        price: function(price) {
            return theme.Currency.formatMoney(price, window.money.moneyFormat);
        },
        getImage: function(images) {
            return images.length > 1 ? images[1] : images[0]
        },
        removeWishlist: function(handle) {
            var index = wishlist.wishlistIndex(this.wishlistData, handle);
            wishlist.removeWishlist(this.wishlistData, index);
            wishlist.removeWishlist(this.products, index);
            wishlist.saveWishlist(this.wishlistData);
        }
    }
});

/*quickview*/

var quickview = {
    init: function() {

    },
    unload: function() {
        // do not find any solution yet
    }
};



// onload
$(function() {
   refine.init();
   collectionFilter.init();
    wishlist.init();
    if ($('body').hasClass('page-wishlist-app')) {
        wishlistApp.fetchWishlist();
    }

});

// init object
window.mh = {
   refine:refine,
   collectionFilter:collectionFilter,
    wishlistData: wishlistData,
    wishlist: wishlist,
    wishlistApp: wishlistApp,
    quickview: quickview
}
